import { createRestSlice } from "./restSlice";

export type OrganizationInvite = {
  id: string;
  organizationId: string;
  email: string;
  role: string;
  status: "pending" | "accepted" | "rejected";
  expiresAt: Date;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

const organizationInvitesSlice = createRestSlice<OrganizationInvite>("organizationInvites", "/v1/organizations/:organizationId/invites");

export const organizationInvitesReducer = organizationInvitesSlice.reducer;
export const organizationInvitesActions = organizationInvitesSlice.actions;
